import React from "react"
export function MoreOptions(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__more-options"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M4.879 11.472a3.622 3.622 0 013.63 3.615 3.622 3.622 0 01-3.63 3.614 3.622 3.622 0 01-3.629-3.614 3.622 3.622 0 013.629-3.615zm9.26-.047a3.622 3.622 0 013.63 3.615 3.622 3.622 0 01-3.63 3.615 3.622 3.622 0 01-3.629-3.615 3.622 3.622 0 013.63-3.615zM4.88 12.47a2.623 2.623 0 00-2.628 2.618 2.623 2.623 0 002.628 2.617 2.623 2.623 0 002.628-2.617 2.623 2.623 0 00-2.628-2.618zm9.26-.047a2.623 2.623 0 00-2.628 2.618 2.623 2.623 0 002.628 2.618 2.623 2.623 0 002.628-2.618 2.623 2.623 0 00-2.628-2.618zM4.88 1.75a3.622 3.622 0 013.63 3.615 3.622 3.622 0 01-3.63 3.614A3.622 3.622 0 011.25 5.365 3.622 3.622 0 014.879 1.75zm10.013.03l.187.045-.259.964a2.629 2.629 0 00-3.218 1.85 2.616 2.616 0 001.858 3.206 2.63 2.63 0 003.17-1.692l.048-.159.967.259a3.63 3.63 0 01-4.444 2.556 3.613 3.613 0 01-2.566-4.428 3.63 3.63 0 014.257-2.6zm-10.013.967a2.623 2.623 0 00-2.628 2.618A2.623 2.623 0 004.88 7.982a2.623 2.623 0 002.628-2.617 2.623 2.623 0 00-2.628-2.618zm13.222-.718l.65.758-3.74 3.188a.502.502 0 01-.64.01l-.064-.062-1.236-1.422.757-.654.91 1.047 3.363-2.865z"
          fill="currentColor"
          fillRule="nonzero"
          id="prefix__options"
        />
      </g>
    </svg>
  )
}
